import {
  GET_ALL_CATEGORY,
  SHOP_BY_BRAND,
  SHOP_BY_CATEGORY,
} from "actions/types";
import axios from "api/axiosInstance";
import API_LIST from "./apiList";
import SystemConstant from "constants/SystemConstant";
import { setAlert } from "./appActions";

export function getAllCategories(access_code) {
  return async (dispatch) => {
    // const headers = SystemConstant.adminRequestHeaders; 
    const headers = SystemConstant.getUserRequestHeaders();
    headers["x-publishable-api-key"] = process.env.REACT_APP_X_PUBLISHER_API_KEY;
    const postBody = {
      categoryType: "All",
      accessId: access_code,
    };
    await axios
      .post(API_LIST.getCategory, postBody, { headers })
      .then((res) => {
        if (res.data) {
          dispatch(getAllCategoriesSuccess(res.data));
        } else {
          dispatch(
            setAlert(
              `${SystemConstant.somethingWentWrongText}`,
              SystemConstant.warning
            )
          );
        }
      })
      .catch(() => {
        dispatch(
          setAlert(
            `${SystemConstant.somethingWentWrongText}`,
            SystemConstant.warning
          )
        );
      });
  };
}
export function getShopByCategory() {
  return async (dispatch) => {
    // const headers = SystemConstant.adminRequestHeaders;
    const headers = SystemConstant.getUserRequestHeaders();
    headers["x-publishable-api-key"] = process.env.REACT_APP_X_PUBLISHER_API_KEY;

    const access_code = SystemConstant.getCookieValue("access_code");
    const postBody = {
      categoryType: "category",
      accessId: access_code,
    };
    await axios
      .post(API_LIST.getCategory, postBody, { headers })
      .then((res) => {
        if (res.data) {
          dispatch(getShopByCategorySuccess(res.data));
        } else {
          dispatch(
            setAlert(
              `${SystemConstant.somethingWentWrongText}`,
              SystemConstant.warning
            )
          );
        }
      })
      .catch(() => {
        dispatch(
          setAlert(
            `${SystemConstant.somethingWentWrongText}`,
            SystemConstant.warning
          )
        );
      });
  };
}

export function getShopByBrandAction(access_code) {
  return async (dispatch) => {
    // const headers = SystemConstant.adminRequestHeaders;
    const headers = SystemConstant.getUserRequestHeaders();
    headers["x-publishable-api-key"] = process.env.REACT_APP_X_PUBLISHER_API_KEY;

    const postBody = {
      categoryType: "brand",
      accessId: access_code,
    };


    await axios
      .post(API_LIST.getCategory, postBody, { headers })
      .then((res) => {
        if (res.data) {
          dispatch(getShopByBrandSuccess(res.data));
        } else {
          dispatch(
            setAlert(
              `${SystemConstant.somethingWentWrongText}`,
              SystemConstant.warning
            )
          );
        }
      })
      .catch(() => {
        dispatch(
          setAlert(
            `${SystemConstant.somethingWentWrongText}`,
            SystemConstant.warning
          )
        );
      });
  };
}

export function getAllCategoriesSuccess(response) {
  return {
    type: GET_ALL_CATEGORY,
    payload: response,
  };
}

export function getShopByBrandSuccess(response) {
  return {
    type: SHOP_BY_BRAND,
    payload: response,
  };
}

export function getShopByCategorySuccess(response) {
  return {
    type: SHOP_BY_CATEGORY,
    payload: response,
  };
}
